<template>
    <div class="loader">
      <LottieAnimation :options="defaultOptions"/>
    </div>
</template>

<script>

import LottieAnimation from 'vue-lottie';
import * as loadDark from '../../static/loader-dark.lottie.json';
import * as loadLight from '../../static/loader-light.lottie.json';

export default {
  name: 'loader',
  components: {
    LottieAnimation,
  },
  props: ['light'],
  data() {
    return {
      defaultOptions: { animationData: this.$props.light ? loadDark : loadLight },
    };
  },
};
</script>

<style scoped>
  .loader {
    position: relative;
  }
</style>



// WEBPACK FOOTER //
// src/components/loader.component.vue